/***
 *
 *   CONTACTS PAGE
 *   Reference ContactsListView shell: page header + the ProjectContacts table
 *   (toolbar, filters, pagination and the loading state all live in that
 *   component now, so the page no longer renders a skeleton of its own).
 *
 **********/

import React from 'react';
import { Animate, useProjectContext } from 'components/lib';
import { useUsers, useProjectUsers } from '../../components/hooks/users';
import ProjectContacts from 'views/settings/projects/contacts';
import { useTranslate } from 'app/translations';
import Style from './contacts.tailwind';

const Contacts = () => {
    const { _t } = useTranslate();
    const { selectedProject } = useProjectContext();

    const projectUsers = useProjectUsers(selectedProject?.id);
    const users = useUsers(selectedProject?.id);

    return (
        <Animate>
            <div className={Style.shell}>
                <div className={Style.header}>
                    <h1 className={Style.title}>{_t('contact.label.multiple')}</h1>
                    <p className={Style.description}>{_t('contact.inviteOrganization')}</p>
                </div>

                <ProjectContacts variant="page" users={users} projectUsers={projectUsers} />
            </div>
        </Animate>
    );
};

export default Contacts;
